<template>
  <div class="fullPage">
    <page :load="doInit">
      <v-layout row wrap>
        <v-flex md12 lg8>
          <v-card class="queryPnl">
            <card-avatar :userId="user.userId" :fname="user.firstName" :lname="user.lastName">
              <div slot="action">
                <v-tooltip top v-if="user.acctBlocked">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="queryLimit">
                      <v-icon color="red">mdi-block-helper</v-icon>
                    </v-btn>
                  </template>
                  <span>User account is blocked from login</span>
                </v-tooltip>
                <v-tooltip top v-if="user.acctDisabled">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="queryLimit">
                      <v-icon color="red">mdi-lock</v-icon>
                    </v-btn>
                  </template>
                  <span>User account is disabled</span>
                </v-tooltip>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="queryLimit">
                      <v-icon color="green">mdi-lock-open</v-icon>
                    </v-btn>
                  </template>
                  <span>User account is not disabled</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="doReview">
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
              </div>
            </card-avatar>
            <v-tabs centered>
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab ripple>
                Details
              </v-tab>
              <v-tab ripple>
                Login History
              </v-tab>
              <v-tab-item>
                <user-details :user="user" :roles="roles" :usrBranches="usrBranches"></user-details>
              </v-tab-item>
              <v-tab-item>
                <v-card-text>
                  <login-history :apiURI="menu.loginHistory" :usrId="user.userId"></login-history>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
            </v-card>
        </v-flex>
      </v-layout>
    </page>
  </div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import CardAvatar from '@/components/reusable/CardAvatar'
import UserDetails from './query/UserDetails'
import LoginHistory from './query/LoginHistory'
import { extractMenu } from '@/utils/extract'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      user: {
        userId: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        mobileNo: undefined,
        officeNo: undefined,
        passwordChange: undefined,
        passwordDate: undefined,
        acctDisabled: undefined,
        createdDate: undefined,
        acctBlocked: undefined,
        superAdmin: undefined,
        roles: [],
        intermediary: undefined,
        intermediaryName: undefined,
        usrRefId: undefined,
        usrBranches: []
      },
      roles: [],
      menu: [],
      usrBranches: []
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.queryUser(), this.getRoles(), this.getBranchList()])
    },
    async queryUser() {
      try {
        const apiURI = this.$store.state.adminUser.menu.userGet
        const expand = {
          id: this.id
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          // User data init
          this.user.userId = data.user.userId
          this.user.firstName = data.user.firstName
          this.user.lastName = data.user.lastName
          this.user.email = data.user.email
          this.user.mobileNo = data.user.mobileNo
          this.user.officeNo = data.user.officeNo
          this.user.passwordChange = data.user.passwordChange
          this.user.passwordDate = data.user.passwordDate
          this.user.acctDisabled = data.user.acctDisabled
          this.user.createdDate = data.user.createdDate
          this.user.acctBlocked = data.user.acctBlocked
          this.user.superAdmin = data.user.superAdmin
          this.user.roles = data.user.roles
          this.user.intermediary = data.user.intermediary
          this.user.intermediaryName = data.user.intermediaryName
          this.user.usrRefId = data.user.usrRefId
          this.user.usrBranches = data.user.usrBranches
          // Extract menu
          this.menu = extractMenu(result.data._links)
        }
      } catch (error) {
        throw error
      }
    },
    async getRoles() {
      const apiURI = this.$store.state.adminUser.menu.roles
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.roles = data.data.roles
        }
      } catch (err) {
        throw err
      }
    },
    doReview() {
      this.$router.push({ name: 'userReview', params: { id: this.id } })
    },
    queryLimit() {
      this.$toast.warning('Cannot do this in query mode')
    },
    async getBranchList() {
      const apiUrl = this.$store.state.commons.menu.commonDataList
      if (apiUrl) {
        const params = {
          listName: 'branchList',
          paramString: ''
        }
        const result = await this.$http.get(expandURI(apiUrl, params))
        if (result.data.dataList) {
          this.$set(this, 'usrBranches', result.data.dataList)
        }
      }
    }
  },
  props: ['id'],
  components: {
    CardAvatar,
    UserDetails,
    LoginHistory
  },
  mixins: [
    commonAjaxMixin
  ]
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
</style>
